export const WEBSITE_TAB_TITLE = "common.website";
export const KEYWORD_TAB_TITLE = "common.keyword";
export const ALL_TAB_TITLE = "common.all";
export const REPORTS_TAB_TITLE = "quick.search.tab.reports";
export const ALL_PLACEHOLDER = "activation.home.search.all.input.placeholder";
export const WEBSITE_PLACEHOLDER = "activation.home.search.website.input.placeholder";
export const KEYWORD_PLACEHOLDER = "activation.home.search.keyword.input.placeholder";
export const REPORTS_PLACEHOLDER = "quick.search.reports.placeholder";
export const FALLBACK_PLACEHOLDER = "quick.search.default.placeholder";
export const ALL_TAB_SHOW_MORE = "quick.search.all.show_more";
export const ALL_TAB_SHOW_LESS = "quick.search.all.show_less";
/** Title when quick search has no matches and the user typed a query. Phrase: `No results found for "%query%"` (typographic quotes optional). */
export const QUICK_SEARCH_NO_RESULTS_TITLE = "quick.search.no_results.title";
/** Secondary line under the empty-state title (Figma). */
export const QUICK_SEARCH_NO_RESULTS_HINT = "quick.search.no_results.hint";
/** Title when there is no search query context (e.g. locked tab with no items). */
export const QUICK_SEARCH_NO_RESULTS_GENERIC = "quick.search.no_results.generic";
